import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import { stateComponentComplete } from '../../../models'
import { sendDataLayer } from '../../../helpers'
import FaqList from '../../SoyMas/components/QuestionList'

const faqs = [
    {
        question: 'Primarias',
        answer: (
            <div>
                <p>Las cuales son necesarias para dar cumplimiento a nuestras obligaciones legales, por lo cual no están sujetas a su consentimiento:</p><br/>
                <ul>
                    <li>
                        Cumplir los requerimientos obligatorios con las leyes vigentes en México.
                    </li>
                    <li>
                        Verificar y confirmar su identidad.
                    </li>
                    <li>
                        Confirmar la información que nos proporciona como Titular de los Datos.
                    </li>
                </ul>
            </div>
        )
    },
    {
        question: 'Secundarias',
        answer: (
            <div>
                <p>En caso de que usted nos otorgue su consentimiento, sus datos personales serán tratados 
                    para las siguientes finalidades secundarias, las cuales no son necesarias para dar cumplimiento 
                    a nuestras obligaciones legales, por lo cual usted puede manifestar su negación al tratamiento 
                    de sus datos personales para estas finalidades en cualquier momento en el mecanismo de oposición 
                    que se informa más adelante.</p><br/>
                <ul>
                    <li>
                        Utilizar sus datos personales de contacto, con la finalidad de informarle sobre servicios o productos 
                        que difunda Profuturo, mismos que son otorgados por empresas subsidiarias o afiliadas de Profuturo o 
                        del mismo grupo empresarial al que pertenece o de Sociedades con las que Profuturo tenga nexo patrimonial.
                    </li>
                </ul>
                <ul>
                    <li>
                        Contactarlo para que usted evalúe la calidad de la información que le brindamos respecto de los servicios o 
                        productos que difunda Profuturo, mismos que son otorgados por empresas subsidiarias o afiliadas de Profuturo o 
                        del mismo grupo empresarial al que pertenece o de Sociedades con las que Profuturo tenga nexo patrimonial.
                    </li>
                </ul>
                <ul>
                    <li>
                        Envío de boletines vía correo electrónico con información de servicios y recomendaciones que difunda Profuturo, 
                        mismos que son otorgados por empresas subsidiarias o afiliadas de Profuturo o del mismo grupo empresarial al que 
                        pertenece o de Sociedades con las que Profuturo tenga nexo patrimonial.
                    </li>
                </ul>
                <ul>
                    <li>
                        Invitarlo a participar en campañas de promociones que difunda Profuturo respecto de servicios que otorguen empresas 
                        subsidiarias o afiliadas de Profuturo o del mismo grupo empresarial al que pertenece o de Sociedades con las que 
                        Profuturo tenga nexo patrimonial.
                    </li>
                </ul>
                <ul>
                    <li>
                        Participación en algunos testimoniales, estudios de mercado, encuestas, entrevistas, experiencias de marca relacionadas 
                        con los servicios o productos que difunda Profuturo, mismos que son otorgados por empresas subsidiarias o afiliadas de 
                        Profuturo o del mismo grupo empresarial al que pertenece o de Sociedades con las que Profuturo tenga nexo patrimonial.
                    </li>
                </ul>
                <ul>
                    <li>
                        Gestionar su participación e inscripción en el programa de lealtad Soy+, ya sea directamente o a través de empresas 
                        subsidiarias o afiliadas de Profuturo o del mismo grupo empresarial o consorcio al que pertenece o de Sociedades con 
                        las que Profuturo tenga nexo patrimonial. Lo cual incluye el registro, administración y activación de su membresía, 
                        así como el envío de comunicaciones, promociones y beneficios asociados a dicho programa.
                    </li>
                </ul>
                <ul>
                    <li>
                        Para fines mercadotécnicos, publicitarios y/o de prospección comercial y perfilamiento para oferta de productos, 
                        servicios y beneficios patrimoniales de empresas subsidiarias o afiliadas de Profuturo o del mismo grupo empresarial 
                        al que pertenece o de Sociedades con las que Profuturo tenga nexo patrimonial.
                    </li>
                </ul>
            </div>
        )
    },
]

const Finalidades = () => {
    const location = useLocation()

    const [render, setRender] = useState<stateComponentComplete>({ ready: false})
    useEffect(() => {
        if (render.ready) sendDataLayer('onload-HomeAviso', location.pathname)
        setRender({ ready: true})
    }, [location.pathname, render.ready])
    return (
        <main className='container_aviso'>
            <section className='container_finalid'>
                <div className='container_fin'>
                    <p className='subtitle_aviso'>Finalidades</p>
                    <FaqList 
                        faqs={faqs} 
                        className= "faq_finalidades"
                        />                     
                    
                    <div className='divider'></div><br/>

                    <p className='subtitle_aviso'>Medios para manifestar su oposición al uso de su información para Finalidades Secundarias</p>
                    <p className='text_general'>
                        En caso de que no desee que sus datos personales sean utilizados para estas Finalidades Secundarias usted 
                        puede oponerse desde este momento a través de la Oficina de Datos Personales, 
                        correo electrónico <span className='span_text_aviso'>datospersonales@profuturo.com.mx</span>
                        <br/><br/>
                        Profuturo le garantiza que puede oponerse a que usemos sus datos personales para las finalidades secundarias.
                    </p><br />

                    <div className='divider'></div><br/>
                </div>

            </section>
        </main>
    )
}

export default Finalidades